import React, { useEffect, useState } from "react";

import {
  DashboardGuidelinesModal,
  PlanogramCard,
  PlanogramDataGrid,
  StoreNameBanner,
  StoreRankCard,
  StoreRankProgressBar,
} from "../../Components";
import { Box, Button, Divider, Typography, useMediaQuery } from "@mui/material";
import {
  PlanoButton,
  PlanoLoaderModal,
  PlanoModal,
  PlanoTypography,
} from "../../Common";
import { getData, postData, xlsxConvertFunc } from "../../Hooks/apiCalls";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  openSideBarModal,
  setLoc,
  setLocation,
  setTokenErr,
} from "../../Store/Common/commonStore";
import { TbFileUpload } from "react-icons/tb";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { isDevelopment } from "../../Hooks/constants.js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import {
  setNewDownloadVersion,
  setStoreNameText,
  setVersionDate,
} from "../../Store/Dashboard/dashboardStore.js";
import Cookies from "js-cookie";

import styles from "./Styles.module.css";
import { compressImage } from "../../Hooks/compressImage.js";
import SemiCircularProgressBar from "../../Components/SemicircularProgressBar/index.jsx";
const Dashboard = () => {
  const loc = Cookies.get("ssp_loc");

  const locationPathname = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorModal, setErrorModal] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Adjust breakpoint as needed
  //UseState Values / useref Value
  const [skuData, setSkuData] = useState({
    listing: 0,
    delisting: 0,
    skuCount: 0,
    timelinessProgress: 0,
    store_rank: "N/A",
    last_plano_execution_date: "",
    last_refresh_date: "",
    plano_score: 0,
  });
  const [loader, setLoader] = useState(false);
  const [guidelinesModal, setGuidelinesModal] = useState(false);
  const [logData, setLogData] = useState([]);
  const [openUploadsModal, setOpenUploadsModal] = useState(false);
  const [uploadDetailsLoader, setUploadDetailsLoader] = useState(false);
  const [uploadDetailsData, setUploadDetailsData] = useState([]);
  const [imageUploadingLoader, setImageUploadingLoader] = useState(false);
  //UseSelector Values
  const token = useSelector((state) => state.common.token);
  const versionDate = useSelector((state) => state.dashboard.versionDate);

  const toShowVersionDate = versionDate.split("T")[0] || "";

  const handleGuidelinesModal = () => {
    setGuidelinesModal(!guidelinesModal);
  };

  const excdate = (value) => {
    if (!value || typeof value !== "string") {
      return "N/A";
    }

    const parts = value.split("T");
    if (parts.length > 0) {
      return parts[0];
    }

    return "N/A";
  };

  const calculateTransformedValue = (receivedValue) => {
    const numValue = Number(receivedValue);

    if (isNaN(numValue)) {
      return 0;
    }
    const baseValue = numValue - 80;
    const clampedMin = Math.max(0, baseValue);
    const finalValue = Math.min(20, clampedMin);
    return finalValue;
  };
  const timelinessProgressValue = calculateTransformedValue(
    skuData?.timelinessProgress,
  );

  const getStoreName = async () => {
    const { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getLocDetails?loc=${loc}`,
      true,
    );

    if (data.status === "success") {
      dispatch(setVersionDate(data?.data[0]?.version_date));
      dispatch(setNewDownloadVersion(data.data[0].new_version));
      dispatch(setStoreNameText(data.data[0].loc_name));
    }
  };
  const downloadSheet = async (newVersion = false) => {
    setLoader(true);
    let response = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getStorePlanogram?loc=${loc}&new_version=${newVersion}`,
      true,
      true,
    );
    if (response.headers["content-type"] !== "application/json") {
      xlsxConvertFunc(
        response.data,
        response.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim(),
      );
      getPlanoLogger();
      getListedDelistedData(loc);
      if (newVersion) {
        // dispatch(setNewDownloadVersion(false));
        getStoreName();
      }
      setLoader(false);
    } else {
      if (response.data.message === "Error While hitting the Api") {
        setLoader(false);
        toast.error(response.data.message, {
          autoClose: 1500,
        });
        dispatch(setTokenErr(true));
        return;
      }
      let { data } = await getData(
        `${
          isDevelopment
            ? process.env.REACT_APP_APIKEY_DEV
            : process.env.REACT_APP_APIKEY_PROD
        }getStorePlanogram?loc=${loc}&new_version=${newVersion}`,
        true,
      );
      setLoader(false);
      toast.error(data.message, {
        autoClose: 1500,
      });
    }
  };

  const getListedDelistedData = async (locData) => {
    if (locData === "") {
      return;
    }
    setLoader(true);
    const { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getLocListingDetails?loc=${locData}`,
      true,
    );
    if (data.status === "success") {
      setSkuData(data.data[0]);
      getPlanoLogger();
      setLoader(false);
      setUploadDetailsLoader(false);
      setOpenUploadsModal(false);
    } else {
      setSkuData({
        listing: 0,
        delisting: 0,
        skuCount: 0,
        timelinessProgress: 0,
        store_rank: "N/A",
      });
      setLoader(false);
      setUploadDetailsLoader(false);
      dispatch(setTokenErr(true));
    }
  };

  const getListedDownload = async (locData) => {
    if (locData === "") {
      return;
    }
    setLoader(true);

    let response = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getStoreListingItems?loc=${locData}`,
      true,
      true,
    );

    if (response.headers["content-type"] !== "application/json") {
      xlsxConvertFunc(
        response.data,
        response.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim(),
      );
      getPlanoLogger();
      getListedDelistedData(loc);
      setLoader(false);
    } else {
      let { data } = await getData(
        `${
          isDevelopment
            ? process.env.REACT_APP_APIKEY_DEV
            : process.env.REACT_APP_APIKEY_PROD
        }getStoreListingItems?loc=${locData}`,
        true,
      );
      setLoader(false);
      toast.error(data.message, {
        autoClose: 1500,
      });
    }
  };

  const getDeListedDownload = async (locData) => {
    if (locData === "") {
      return;
    }
    setLoader(true);

    let response = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getStoreDelistingItems?loc=${locData}`,
      true,
      true,
    );

    if (response.headers["content-type"] !== "application/json") {
      xlsxConvertFunc(
        response.data,
        response.headers["content-disposition"]
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim(),
      );
      getPlanoLogger();
      getListedDelistedData(loc);
      setLoader(false);
    } else {
      let { data } = await getData(
        `${
          isDevelopment
            ? process.env.REACT_APP_APIKEY_DEV
            : process.env.REACT_APP_APIKEY_PROD
        }getStoreDelistingItems?loc=${locData}`,
        true,
      );
      setLoader(false);

      toast.error(data.message, {
        autoClose: 1500,
      });
    }
  };
  const getPlanoLogger = async () => {
    setLoader(true);

    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getLocPlanoLogger?loc=${loc}`,
      true,
    );
    if (data.status === "success") {
      setLogData(data.data);
      setLoader(false);
    } else {
      setLoader(false);
      toast.error(data.message);
      dispatch(setTokenErr(true));
    }
  };

  const uploadImage = async (fileUploadImage, bayNo, versionDate) => {
    setImageUploadingLoader(true);
    setUploadDetailsLoader(true);

    const baseUrl = isDevelopment
      ? process.env.REACT_APP_APIKEY_DEV
      : process.env.REACT_APP_APIKEY_PROD;

    try {
      // STEP 1: Get the S3 Pre-signed POST Data
      const presignedResponse = await getData(
        `${baseUrl}getplanopresignedurl?loc=${loc}&bay_number=${bayNo}&version_date=${versionDate}&fileName=${fileUploadImage.name}`,
        true,
      );

      if (presignedResponse.data.status !== "success") {
        setImageUploadingLoader(false);
        setUploadDetailsLoader(false);
        throw new Error(
          presignedResponse.data.message || "Failed to get pre-signed URL",
        );
      }

      // Extract the base URL and the security fields from the new JSON structure
      const s3Url = presignedResponse.data.data.upload_url.url;
      const s3Fields = presignedResponse.data.data.upload_url.fields;
      const s3ObjectName = presignedResponse.data.data.object_name;

      // STEP 2: Upload the image to S3 using FormData
      const formData = new FormData();

      // 1. Append all the required AWS security and policy fields FIRST
      Object.entries(s3Fields).forEach(([key, value]) => {
        formData.append(key, value);
      });

      // 2. Append the actual file object LAST (AWS requires 'file' to be the key)
      formData.append("file", fileUploadImage);

      // 3. Send the POST request to AWS
      const s3UploadResponse = await axios.post(s3Url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      // S3 Pre-signed POSTs typically return a 204 No Content status on success
      if (s3UploadResponse.status !== 200 && s3UploadResponse.status !== 204) {
        setImageUploadingLoader(false);
        setUploadDetailsLoader(false);
        throw new Error("Failed to upload image to S3 bucket");
      }

      // STEP 3: Notify Backend that the upload is complete
      const payload = {
        object_name: s3ObjectName,
        loc: loc,
        bay_number: bayNo,
        version_date: versionDate,
      };

      const notifyResponse = await postData(
        `${baseUrl}uploadplanoimage`,
        true,
        false,
        payload,
        false,
      );

      if (notifyResponse.data.status === "success") {
        toast.success(
          notifyResponse.data.message || "Image uploaded successfully",
          { autoClose: 1500 },
        );
        setImageUploadingLoader(false);
        setUploadDetailsLoader(false);
        getUploadBayImagesData();
      } else {
        toast.error("Error While Uploading Please try Again");
        setErrorModal(true);
        setErrorModalMessage(
          notifyResponse.data?.data?.[0]?.comments ||
            notifyResponse.data.message ||
            "Unknown error occurred",
        );
        setImageUploadingLoader(false);
        setUploadDetailsLoader(false);
      }
    } catch (err) {
      setImageUploadingLoader(false);
      setUploadDetailsLoader(false);
      console.log("API failed to upload the image : ", err);

      toast.error("Error While Uploading Please try Again");
      setErrorModal(true);
      setErrorModalMessage(
        err.response?.data?.message || err.message || "Network Error",
      );
    }
  };

  const getUploadBayImagesData = async () => {
    setUploadDetailsLoader(true);
    let { data } = await getData(
      `${
        isDevelopment
          ? process.env.REACT_APP_APIKEY_DEV
          : process.env.REACT_APP_APIKEY_PROD
      }getbayimages?loc=${loc}&version_date=${versionDate}`,
      true,
    );
    if (data.status === "success") {
      setUploadDetailsData(data.data);
      // handleOpenUploadsModal();
      setOpenUploadsModal(true);
      setUploadDetailsLoader(false);
    } else {
      setUploadDetailsLoader(false);
      toast.error(data.message);
    }
  };
  useEffect(() => {
    dispatch(openSideBarModal(false));
    dispatch(setLoc(loc));
    getListedDelistedData(loc);
  }, [loc, navigate]);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const ModalForUploadPhotos = ({ data }) => {
    const handleFileChange = async (event, bayNo, versionDate) => {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      // Optional: Give user feedback that compression is happening
      const toastId = toast.loading("Compressing image...");

      try {
        const compressedFile = await compressImage(file, 1.5); // Target 1.5 MB

        toast.update(toastId, { render: "Uploading...", type: "info" });

        // Now call your original upload function with the compressed file
        await uploadImage(compressedFile, bayNo, versionDate);

        // The uploadImage function already handles success/error toasts, so we just dismiss this one on success
        toast.dismiss(toastId);
      } catch (error) {
        console.error("Image compression failed:", error);
        toast.update(toastId, {
          render: "Compression failed!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      }
    };
    return (
      <Box>
        <Box className={styles.modalUploadPhotosBody1}>
          <PlanoTypography className={styles.modalUploadPhotosHeaderText}>
            Bay Number
          </PlanoTypography>
          <PlanoTypography className={styles.modalUploadPhotosHeaderText}>
            Upload Bay Images
          </PlanoTypography>
        </Box>

        <Box className={styles.modalUploadPhotosUploadBoxBody}>
          {data.map((row, index) => (
            <Box
              className={styles.modalUploadPhotosUploadBoxItemsBody}
              key={index}>
              <PlanoTypography
                className={styles.modalUploadPhotosUploadBoxItemsText}>
                {row.bay_no}
              </PlanoTypography>
              <Box width={"30%"}>
                {row.upload_status === "N" ? (
                  <Button
                    disabled={!isSmallScreen}
                    className={
                      !isSmallScreen
                        ? styles.modalUploadPhotosItemsUploadButtonDisabled
                        : styles.modalUploadPhotosItemsUploadButton
                    }
                    component="label">
                    Upload
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/jpeg"
                      capture="environment"
                      onChange={(e) => {
                        handleFileChange(e, row.bay_no, row.version_date);
                      }}
                    />
                  </Button>
                ) : (
                  <Button
                    className={
                      !isSmallScreen
                        ? styles.modalUploadPhotosItemsUploadButtonDisabled
                        : styles.modalUploadPhotosItemsUploadButton
                    }
                    component="label"
                    disabled={!isSmallScreen}>
                    Re-Upload
                    <VisuallyHiddenInput
                      type="file"
                      accept="image/jpeg"
                      capture="environment"
                      onChange={(e) => {
                        handleFileChange(e, row.bay_no, row.version_date);
                      }}
                    />
                  </Button>
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  const totalUploadsDone =
    uploadDetailsData.filter((obj) => obj.upload_status !== "N").length || 0;

  return (
    <Box className={styles.body}>
      <StoreNameBanner />
      {isSmallScreen ? (
        <Box className={styles.container1sm}>
          {/* ---2--- */}
          <Box className={styles.container2sm}>
            <Box height={"118px"}>
              <Box className={styles.container2HeaderText}>
                <PlanoTypography className={styles.plainText}>
                  Implementation Validation
                </PlanoTypography>
              </Box>
              <Box className={styles.uploadPhotosButtonContainer}>
                <Button
                  className={styles.uploadPhotosButton}
                  component="label"
                  startIcon={<TbFileUpload className={styles.commonIconSize} />}
                  onClick={getUploadBayImagesData}>
                  Upload Photos
                </Button>
                <Typography fontSize={12}>
                  {totalUploadsDone === uploadDetailsData.length ? (
                    ""
                  ) : totalUploadsDone === 0 ? (
                    "**JPEG (150KB)"
                  ) : (
                    <span className={styles.pendingUploadText}>
                      !! pending upload
                    </span>
                  )}{" "}
                </Typography>
              </Box>
            </Box>
            <Divider variant="middle" />
            <Box pl={2} mt={1}></Box>
            {/* <Box className={styles.progressBarContainer}>
              <StoreRankProgressBar percentage={skuData.timelinessProgress} />
            </Box> */}
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "200px" }}>
                <SemiCircularProgressBar
                  value={skuData.plano_score}
                  title="Planogram Adherence Score"
                  startTitle={0}
                  endTitle={100}
                />
              </div>

              <div style={{ width: "200px" }}>
                <SemiCircularProgressBar
                  value={timelinessProgressValue}
                  title="Time to Refresh"
                  max={20}
                  startTitle={0}
                  endTitle={20}
                />
              </div>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
              p={2}
              className={styles.blink_me}>
              <span>
                Last Plano Execution Date :{" "}
                {excdate(skuData?.last_plano_execution_date)}
              </span>
              <span>
                Last Refresh Date: {excdate(skuData?.last_refresh_date)}
              </span>
            </Box>
            <Box className={styles.storeRanksContainer}>
              <StoreRankCard rank={skuData.store_rank} />
              <StoreRankCard
                rank={skuData.listing}
                text={"ListedSKU"}
                downloadButton={true}
                downloadBtnFunction={getListedDownload}
              />
              <StoreRankCard
                rank={skuData.delisting}
                text={"De-listedSKU"}
                downloadButton={true}
                downloadBtnFunction={getDeListedDownload}
              />
            </Box>
          </Box>
          {/* ----1---- */}
          <PlanogramCard
            storeRank={skuData.timelinessProgress}
            downloadBtn={downloadSheet}
          />
        </Box>
      ) : (
        <Box className={styles.container1}>
          {/* ----1---- */}

          <PlanogramCard
            storeRank={skuData.timelinessProgress}
            downloadBtn={downloadSheet}
          />

          {/* ---2--- */}
          <Box className={styles.container2}>
            <Box>
              <Box className={styles.container2HeaderText}>
                <PlanoTypography className={styles.plainText}>
                  Implementation Validation
                </PlanoTypography>
              </Box>
              <Box className={styles.uploadPhotosButtonContainer}>
                <Button
                  className={styles.uploadPhotosButton}
                  startIcon={<TbFileUpload className={styles.commonIconSize} />}
                  onClick={getUploadBayImagesData}>
                  Upload Photos
                </Button>
                <Typography fontSize={12}>
                  {totalUploadsDone === uploadDetailsData.length ? (
                    ""
                  ) : totalUploadsDone === 0 ? (
                    "**JPEG (150KB)"
                  ) : (
                    <span className={styles.pendingUploadText}>
                      !! pending upload
                    </span>
                  )}{" "}
                </Typography>
              </Box>
              <Divider variant="middle" />
            </Box>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "8px",
                // border: "1px solid",
                // flexWrap: "wrap",
              }}>
              <div style={{ width: "200px" }}>
                <SemiCircularProgressBar
                  value={skuData.plano_score}
                  title="Planogram Adherence Score"
                  startTitle={0}
                  endTitle={100}
                />
              </div>

              <div style={{ width: "200px" }}>
                <SemiCircularProgressBar
                  value={timelinessProgressValue}
                  title="Time to Refresh"
                  max={20}
                  startTitle={0}
                  endTitle={20}
                />
              </div>
              <div className={styles.progressAndStoreRankBody}>
                <div className={styles.storeRanksContainer}>
                  {/* <StoreRankCard rank={skuData.store_rank} /> */}
                  <StoreRankCard
                    rank={skuData.listing}
                    text={"ListedSKU"}
                    downloadButton={true}
                    downloadBtnFunction={getListedDownload}
                  />
                  <StoreRankCard
                    rank={skuData.delisting}
                    text={"De-listedSKU"}
                    downloadButton={true}
                    downloadBtnFunction={getDeListedDownload}
                  />
                </div>
                <div
                  mt={2}
                  className={styles.blink_me}
                  style={{ display: "flex", flexDirection: "column" }}>
                  <span>
                    Last Plano Execution Date :{" "}
                    {excdate(skuData?.last_plano_execution_date)}
                  </span>
                  <span>
                    Last Refresh Date: {excdate(skuData?.last_refresh_date)}
                  </span>
                </div>
              </div>
            </div>
          </Box>
        </Box>
      )}

      <Box className={styles.logsHeaderContainer}>
        <PlanoTypography className={styles.logsHeaderText}>
          Logs
        </PlanoTypography>
        <PlanogramDataGrid rowData={logData} />
      </Box>

      <DashboardGuidelinesModal
        open={guidelinesModal}
        setOpen={handleGuidelinesModal}
      />
      <PlanoModal
        open={openUploadsModal}
        setOpen={setOpenUploadsModal}
        size={"sm"}
        showHeader={false}
        showFooter={false}
        setLoader={setUploadDetailsLoader}
        loader={uploadDetailsLoader}
        loaderText={
          imageUploadingLoader && "Image is getting uploaded. Please Wait !!!"
        }>
        <PlanoTypography className={styles.versionDateText}>
          Version Date : {toShowVersionDate}
        </PlanoTypography>
        {!isSmallScreen && (
          <PlanoTypography className={styles.useMobile}>
            Use Mobile to Upload Image
          </PlanoTypography>
        )}
        <ModalForUploadPhotos data={uploadDetailsData} />
        <Box className={styles.uploadImageBoxContainer}>
          <PlanoTypography className={styles.uploadImageText}>
            Images Uploaded
          </PlanoTypography>
          <Box className={styles.uploadsDoneTextContainer}>
            <Typography>
              {totalUploadsDone} / {uploadDetailsData.length}
            </Typography>
          </Box>

          {totalUploadsDone === uploadDetailsData.length ? (
            <PlanoButton
              mainfunction={() => {
                setUploadDetailsLoader(true);
                getListedDelistedData(loc);
              }}
              extraCss={{
                width: isSmallScreen ? 80 : 160,
              }}>
              Submit
            </PlanoButton>
          ) : (
            <PlanoButton
              extraCss={{
                width: isSmallScreen ? 120 : 160,
                fontSize: isSmallScreen && "12px",
                textAlign: "center",
                whiteSpace: "nowrap",
              }}
              mainfunction={() => {
                setOpenUploadsModal(false);
              }}>
              Save For Later
            </PlanoButton>
          )}
        </Box>
        <PlanoTypography className={styles.scoreUpdateText}>
          Score will update only upon uploading all images
        </PlanoTypography>
      </PlanoModal>
      <PlanoModal
        open={errorModal}
        setOpen={setErrorModal}
        size="sm"
        showHeader={false}
        showFooter={true}>
        <PlanoTypography className={styles.errorMessageOnUpload}>
          <div>Reupload the Image - {errorModalMessage}</div>
        </PlanoTypography>
      </PlanoModal>
      <PlanoLoaderModal open={loader} setOpen={setLoader} />
    </Box>
  );
};

export default Dashboard;
